module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-community@2x-aa8c2cfbe204ef27eeb0b55df81250aa.png";